import { fg } from '@atlaskit/platform-feature-flags';
import type {
	AiFeatureRequestEnvelopeRovoConvoStarterRecommendationRequest,
	RovoConvoStarterRecommendationResponseSummary,
} from '@atlassian/convo-ai-api';

const ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_RECOMMENDATION';

const CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';

type FetchAgentConvoStartersProps = {
	contentUrl: string;
	numberOfRecommendations: number;
	triggerId: string;
};

export const fetchAgentConvoStarters = async ({
	triggerId,
	numberOfRecommendations,
	contentUrl,
}: FetchAgentConvoStartersProps) => {
	const request: AiFeatureRequestEnvelopeRovoConvoStarterRecommendationRequest = {
		ai_feature_input: {
			triggers: [
				{
					trigger_id: triggerId,
					trigger_details: {
						number_of_recommendations: numberOfRecommendations,
						content_url: contentUrl,
					},
					trigger_type: ROVO_BUTTON_TRIGGER_TYPE,
				},
			],
		},
	};

	const response = await fetch(CONVO_AI_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'X-Product': 'confluence',
			'X-Experience-Id': fg('rovo_button_experience_id_enabled')
				? 'proactive-ai-rovo-button'
				: 'ai-mate',
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(
			`Error fetching agent recommendations and convo starters, status code: ${response.status}`,
		);
	}
	const data = await response.json();
	const content = data?.ai_feature_output;
	if (!content) {
		return undefined;
	}
	return content as RovoConvoStarterRecommendationResponseSummary;
};
